import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {OccupationalProfile} from '../shared/occupational-profile';
import {ExternalReference} from '../shared/external-reference';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';

@Component({
    selector: 'occupational-profile-info-package',
    templateUrl: './occupational-profile-info-package.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OccupationalProfileInfoPackageComponent {

    @Input()
    public occupationalProfile!: OccupationalProfile;

    constructor(private sanitizer: DomSanitizer) {
    }

    private static getExternalReferences(occupationalProfile: OccupationalProfile): Array<ExternalReference> {
        return occupationalProfile.vdabSpecific.externalReferences
            .filter(externalReference => externalReference.type === 'INFO_PACKAGE');
    }

    hasDigitalInfoPackage(occupationalProfile: OccupationalProfile): boolean {
        return OccupationalProfileInfoPackageComponent.getExternalReferences(occupationalProfile).length > 0;
    }

    getDigitalInfoPackageUrl(occupationalProfile: OccupationalProfile): SafeUrl {
        // @ts-expect-error external references are guaranteed non-empty here
		return this.sanitizeUrl(OccupationalProfileInfoPackageComponent.getExternalReferences(occupationalProfile).pop().url);
    }

    private sanitizeUrl(url: string): SafeUrl {
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }

}
